import { render } from "./SubsectorFilter.vue?vue&type=template&id=5b8f9676&scoped=true"
import script from "./SubsectorFilter.vue?vue&type=script&lang=js"
export * from "./SubsectorFilter.vue?vue&type=script&lang=js"

import "./SubsectorFilter.vue?vue&type=style&index=0&id=5b8f9676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8f9676"]])

export default __exports__